import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgRulesDisableYes({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#E3E8E8" cx={12} cy={12} r={12} />
        <path
          d="M7.12 10.43a.75.75 0 01.75 1.3 3.22 3.22 0 104.74 3.55.75.75 0 111.46.35 4.72 4.72 0 11-6.95-5.2zm2-5.68a2.2 2.2 0 01.88 4.2l.02.13h2.51c.38 0 .7.29.74.65l.01.1c0 .42-.34.75-.75.75h-2.2l.39 1.82h4.43c.32 0 .6.2.7.5l1.28 3.7 1.13-.38a.75.75 0 11.48 1.42l-1.84.62a.75.75 0 01-.95-.47l-1.34-3.9h-4.5a.75.75 0 01-.73-.59l-.9-4.25a2.2 2.2 0 01.63-4.3zm0 1.5a.7.7 0 100 1.39.7.7 0 000-1.39z"
          fill="#666"
        />
      </g>
    </svg>
  );
}

SvgRulesDisableYes.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgRulesDisableYes.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgRulesDisableYes svgRef={ref} {...props} />);
export default ForwardRef;
